// 系统管理
import homePage from '../../views/homePage/index'; // 首页
// import homePage from '../../views/homePage/main'; // 首页
import moreInfo from '../../views/homePage/moreInfo'; // 更多信息
export default [
    {
        path: '/homePage',
        name: 'homePage',
        meta: { selfFlg: 'home' },

        component: homePage // 机构管理
    },
    {
        path: '/homePage/moreInfo',
        name: 'moreInfo',
        meta: { title: '更多信息' },
        component: moreInfo // 机构管理
    }
];
